import { render } from "./TareaList.vue?vue&type=template&id=5b5d4094"
import script from "./TareaList.vue?vue&type=script&lang=js"
export * from "./TareaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__